<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="'Bill Autopay'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'When'" /><span>&nbsp;</span>
          <tidy-text
            [body]="pro?.homekeeper?.name" /><span>&nbsp;</span>
            <tidy-text
              [body]="'finishes your jobs they can send you a bill using their TIDY app.'" />
          </tidy-row>
          <tidy-card>
            <tidy-row [alignLastItemRight]="true">
              <tidy-row [alignLastItemRight]="true" class="full-width">
                <tidy-image
                  [src]="allowsInvoiceAutopay ? 'assets/img/checkmark.svg' : 'assets/img/block.svg'"
                  class="header-size" />
                <tidy-text
                  [header]="'Autopay'" />
                <div></div>
              </tidy-row>
              <tidy-toggle
                [toggled]="allowsInvoiceAutopay"
                (toggleChanged)="allowsInvoiceAutopay = !allowsInvoiceAutopay" />
            </tidy-row>
            @if (allowsInvoiceAutopay) {
              <form [formGroup]="form">
                <tidy-row class="field-top-padding">
                  <tidy-input
                    formControlName="autoPayMaxAmount"
                    [label]="'Maximum amount to pay'"
                    [form]="form.controls.autoPayMaxAmount"
                    [icon]="'assets/svg/card.svg'"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter a maximum amount to pay.'"
                    inputMode="numeric"
                    [mask]="'currencyMask'" />
                </tidy-row>
              </form>
            }
          </tidy-card>
          <tidy-button
            [text]="'Save Settings'"
            class="primary"
            [action]="boundSave" />
          @if (errorMessage) {
            <tidy-error-message
              [text]="errorMessage" />
          }
        }
      </tidy-wrapper>
    </ng-template>

    <app-scroll-wrapper [templateContent]="content" />
